import type { ReactNode } from 'react';
import { CircleAlert } from 'lucide-react';
import { errorText } from '@/utils/errors';

/** What a list or page shows when its data could not be loaded: the reason, in Russian. */
export function ErrorState({ error, fallback }: { readonly error: unknown; readonly fallback?: string }): ReactNode {
  return (
    <div className="state state-error" role="alert">
      <CircleAlert size={28} aria-hidden="true" />
      <p>{errorText(error, fallback)}</p>
    </div>
  );
}
